import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CommonService from '../../services/commonService';
import i18next from 'i18next';
import getIcons from '../themes/functions/getIcons/getIcons';

export default class ServiceFilter extends Component {
  static propTypes = {
    filtersArray: PropTypes.array.isRequired,
    onFilterSelected: PropTypes.func.isRequired,
    onFilterClear: PropTypes.func,
    t: PropTypes.func,
    operator: PropTypes.object,
  };

  getSeatName = rawSeat => {
    // console.log('Raw seat'.rawSeat);
    switch (rawSeat) {
      case 'SALON CAMA':
        return 'Salón Cama';
        break;
      case 'Salon Cama':
        return 'Salón Cama';
        break;
      case 'CLASICO':
        return 'Clásico';
        break;
      case 'Clasico':
        return 'Clásico';
        break;
      case 'Salon Sin Vent':
        return 'Salón Sin Vent';
        break;
      case 'SALON SIN VENT':
        return 'Salón Sin Vent';
        break;
      case 'Salon Preferente':
        return 'Salón Preferente';
        break;
      case 'SALON PREFERENTE':
        return 'Salón Preferente';
        break;
      case 'SALON':
        return 'Salón ';
        break;
      case 'Salon':
        return 'Salón ';
        break;
      default:
        return rawSeat;
        break;
    }
  };

  renderFilterItem = (option, onClick) => {
    // console.log(option)
    return (
      <div className={'filter-category-box ' + option.align}>
        {option.type !== 'operator' && (option.type === 'time' || !CommonService.isTrain()) ? (
          <div className="filter-category-title bold-text">
            {this.props.t('RESULTS_PAGE.' + option.title)}
          </div>
        ) : null}
        {option.type !== 'operator' && (option.type == 'time' || !CommonService.isTrain())
          ? option.options.map((val, key) => {
              // console.log('Val######################', val);

              return (
                val.value !== 'pet' && (
                  <div
                    key={key}
                    className={
                      'filter-item pointer ' +
                      (val.active ? 'primary-text active bold-text ' : '') +
                      i18next.language
                    }
                    onClick={() => onClick(key)}
                  >
                    {val.icon ? (
                      <img
                        className="icon-size"
                        src={`/static/images/icons/icon-${val.icon +
                          (val.active ? '-orange' : '')}.png`}
                        alt=""
                      />
                    ) : null}
                    {val.trText
                      ? this.props.t('RESULTS_PAGE.' + val.trText)
                      : this.props.t(this.getSeatName(val.label))}
                  </div>
                )
              );
            })
          : null}
      </div>
    );
  };

  showClearFilter = () => {
    for (let f of this.props.filtersArray) {
      for (let o of f.options) {
        if (o.active) {
          return true;
        }
      }
    }
    return false;
  };

  clearFilter = () => {
    let filters = CommonService.copyObject(this.props.filtersArray);
    for (let f of filters) {
      for (let o of f.options) {
        o.active = false;
      }
    }
    this.props.onFilterClear(filters);
  };
  handlePetFilter = () => {
    const amenities = this.props.filtersArray.find(val => val.type === 'amenities');
    const pet = this.props.filtersArray.find(val => val.value === 'pet');
    console.log('amenities--------', amenities);

    this.props.onFilterSelected(pet, 2, 0);
  };

  renderPetFilter = (option, onClick) => {
    return (
      <div>
        {option &&
          option.type === 'amenities' &&
          option.options.map((val, key) => {
            if (val.value === 'pet') {
              return (
                <div key={key} className="font10 primary-pet">
                  <strong>Asiento Mascota</strong>

                  <img
                    className="primary-pet-icon"
                    // src={`/images/filter On-Button-Filter.svg+ (val.active ? '-orange' : '')}.svg`}
                    // src={`/static/images/seats/${val.active ? 'On' : 'Off'}-Button-Filter.svg`}
                    src={
                      val.active
                        ? getIcons('petfilteron', this.props.operator)
                        : getIcons('petfilteroff', this.props.operator)
                    }
                    onClick={() => onClick(key)}
                    alt=""
                  />
                </div>
              );
            }
          })}
      </div>
    );
  };

  render() {
    let { t } = this.props;
    console.log('services filter', this.props);
    return (
      <div className="common-service-filter filter-container pb-service-list-service-filter">
        <div className=" kupos-card">
          <div className="filter-main-title font13">{t('RESULTS_PAGE.FILTERS')}</div>

          <div>
            {this.props.filtersArray.map((val, key) => {
              return this.renderPetFilter(val, i => this.props.onFilterSelected(val, key, i));
            })}
          </div>
          <div className="filter-box font10">
            {this.props.filtersArray.map((val, key) => {
              return this.renderFilterItem(val, i => this.props.onFilterSelected(val, key, i));
            })}
          </div>
        </div>
        {this.showClearFilter() ? (
          <div className="remove-filter-box pointer font10" onClick={this.clearFilter}>
            <img src="/static/images/icons/close-window.svg" alt="" />
            {t('RESULTS_PAGE.REMOVE_FILTERS')}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/ServiceFilter.js